import React from "react";
import {
  Box,
  Grid,
  TextField,
  MenuItem,
  Button,
  Typography,
  InputLabel,
  OutlinedInput,
  FormControl,
  Select,
  Chip,
  IconButton,
  FormControlLabel,
  Switch,
  Autocomplete,
  createFilterOptions,
  Avatar,
  TextareaAutosize,
  CircularProgress,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import Checkbox from "@mui/material/Checkbox";
import ListItemText from "@mui/material/ListItemText";
import { useState } from "react";
import AppLoader from "../../components/common/AppLoader";
import PhoneNumberField from "../../components/common/PhoneNumberField";

function CastingCallForm({
  onDirectorChange,
  formData,
  dispatch,
  errors,
  setErrors,
  unionOptions,
  locationOptions,
  categoryOptions,
  fileError,
  setFileError,
  filewordError,
  setFilewordError,
  emailError,
  setEmailError,
  phoneError,
  setPhoneError,
  payTypeOptions,
  /* DIRECTOR SEARCH */
  directorResults,
  directorSearch,
  setDirectorSearch,
  directorLoading,
  selectedDirector,
  setSelectedDirector,
  selectedDirectorId,
  setSelectedDirectorId,
  directorDropdownError,
  setDirectorDropdownError,

  /* GENERAL FORM */
  handleSubmit,
  touched,
  setTouched,
  manualRushOverride,
  setManualRushOverride,
  disabledFields,
  isLoading,
  showDirectorDropdown,
}) {
  const userRole = localStorage.getItem("userRole");
  const isAdmin = userRole === "ADMIN";

  const jobCategoryMap = React.useMemo(() => {
    const m = {};
    categoryOptions.forEach(({ id, name }) => {
      m[id] = name;
    });
    return m;
  }, [categoryOptions]);

  const isWithinWeek = (() => {
  if (!formData.removalDate) return false;
  const today = new Date();
  const selected = new Date(formData.removalDate);
  const diffDays = (selected - today) / (1000 * 60 * 60 * 24);
  return diffDays >= 0 && diffDays <= 7;
})();

const handleChange = (e) => {
  const { name, value, type, files } = e.target;

  // Mark field as touched
  setTouched((prev) => ({ ...prev, [name]: true }));

  /* -------------------------------
     JOB CATEGORIES (needs number[])
  --------------------------------*/
  if (name === "jobCategories") {
    const numericIds = value.map((v) =>
      typeof v === "string" ? parseInt(v, 10) : v
    );

    dispatch({
      type: "UPDATE_FIELD",
      field: name,
      value: numericIds,
    });

    validateField(name, numericIds);
    return;
  }

  /* -------------------------------
     FILE HANDLING
  --------------------------------*/
  if (type === "file") {
    const file = files[0];
    if (!file) return;

    const allowedImageExts = [
      "jpg","jpeg","png","gif","webp","svg","bmp","tiff","heic",
    ];
    const allowedScriptExts = ["pdf", "doc", "docx", "otf", "pages"];

    const ext = file.name.split(".").pop().toLowerCase();

    const isImageInput = name === "PicturesFile";
    const isScriptInput = name === "ScriptsFile";

    const isValid =
      (isImageInput && allowedImageExts.includes(ext)) ||
      (isScriptInput && allowedScriptExts.includes(ext));

    if (!isValid) {
      if (isImageInput) {
        setFileError(
          "Invalid file type. Please upload an image file (JPG, PNG, GIF, etc.)"
        );
        dispatch({ type: "UPDATE_FIELD", field: name, value: null });
      } else if (isScriptInput) {
        setFilewordError(
          "Invalid file type. Please upload a document file (PDF, DOC, DOCX, etc.)"
        );
        dispatch({ type: "UPDATE_FIELD", field: name, value: null });
      }
      return;
    }

    dispatch({ type: "UPDATE_FIELD", field: name, value: file });

    if (isImageInput) {
      dispatch({
        type: "SET_MULTIPLE_FIELDS",
        payload: {
          PicturesFile: file,
          PicturesFileName: file.name,
          removePicturesFile: false,
        },
      });
      setFileError("");
    }

    if (isScriptInput) {
      dispatch({
        type: "SET_MULTIPLE_FIELDS",
        payload: {
          ScriptsFile: file,
          ScriptsFileName: file.name,
          removeScriptsFile: false,
        },
      });
      setFilewordError("");
    }

    return;
  }

  /* -------------------------------
     DEFAULT HANDLER (includes unionStatus)
  --------------------------------*/
  dispatch({
    type: "UPDATE_FIELD",
    field: name,
    value, // works for unionStatus (array) and normal fields
  });

  /* -------------------------------
     AUTO RUSH CALL LOGIC
  --------------------------------*/
if (name === "removalDate") {
  const today = new Date();
  const selected = new Date(value);
  const diffDays = (selected - today) / (1000 * 60 * 60 * 24);

  const shouldBeRush = diffDays >= 0 && diffDays <= 7;

  dispatch({
    type: "UPDATE_FIELD",
    field: "rushCall",
    value: shouldBeRush,
  });

  if (shouldBeRush) {
    setManualRushOverride(false); // override manual choice
  }
}

  /* -------------------------------
     VALIDATION
  --------------------------------*/
  validateField(name, value);
};

  const filterOptions = createFilterOptions({
    stringify: (option) =>
      `${option.firstName || ""} ${option.lastName || ""} ${
        option.email || ""
      } ${option.loginName || ""} ${option.userId}`,
  });

  const emailRegex = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/;
const alphaRegex = /^[A-Za-z ]+$/;
  const alphanumRegex = /^[A-Za-z0-9 ]+$/;
  const alphanumSpecialRegex =
    /^[A-Za-z0-9 !@#$%^&*()\-_=+{}\[\]:;"'<>,.?/\\|`~\n\r]+$/;

  const validateField = (name, value) => {
    let error = "";
    switch (name) {
      case "projectTitle":
      case "projectDescription":
      case "castingOrShootDatesInfo":
        if (!value.trim() || !alphanumSpecialRegex.test(value)) {
          error = "Only letters, numbers, and special characters are allowed.";
        }
        break;

      /*       case "contactName":
        if (!value.trim() || !alphaRegex.test(value))
          error = "Only alphabets allowed.";
        break;

      case "company":
        if (!value.trim()) error = "Company is required.";
        break;
 */
     case "contactPhone": {
  if (!value || !value.trim()) {
    error = "Phone number is required.";
  } else if (!/^\d+-\d{4,15}$/.test(value.trim())) {
    error = "Invalid phone number.";
  }
  break;
}

      case "contactEmail":
        if (!emailRegex.test(value)) error = "Invalid email format.";
        break;

      case "payScale":
        if (!value.trim() || !alphanumSpecialRegex.test(value)) {
          error = "Pay Scale is invalid.";
        } else if (value.length > 200) {
          error = "Pay Scale cannot exceed 200 characters.";
        }
        break;

      case "removalDate": {
        const today = new Date();
        const selected = new Date(value);
        if (selected < new Date(today.setHours(0, 0, 0, 0)))
          error = "Date cannot be in the past.";
        break;
      }
      default:
        break;
    }
    setErrors((prev) => ({ ...prev, [name]: error }));
  };

  return (
    <Box
      sx={{ backgroundColor: "#eee", minHeight: "100vh", position: "relative" }}
    >
      {isLoading && (
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            backgroundColor: "rgba(255,255,255,0.7)",
            zIndex: 2000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 2,
          }}
        >
          <AppLoader message="Saving or loading form data..." />
        </Box>
      )}

      <Box sx={{ maxWidth: 1200, mx: "auto", p: 3, borderRadius: 2 }}>
        <TextField
          fullWidth
          name="projectTitle"
          label="Project Title"
          value={formData.projectTitle || ""}
          onChange={handleChange}
          error={!!errors.projectTitle}
          helperText={errors.projectTitle}
          margin="normal"
        />
        {showDirectorDropdown && (
          <Autocomplete
            loading={directorLoading}
            options={directorResults}
            value={selectedDirector}
            onInputChange={(e, value) => setDirectorSearch(value)}
            onChange={(e, newVal) => {
              setSelectedDirector(newVal || null);
              if (newVal) {
                setSelectedDirectorId(newVal.userId);
                onDirectorChange(newVal);
              }
            }}
            getOptionLabel={(opt) =>
              opt
                ? `${opt.firstName || ""} ${opt.lastName || ""} (${opt.email})`
                : ""
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label="Search Director"
                placeholder="Type name/email/login…"
                error={!!directorDropdownError}
                helperText={directorDropdownError}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {directorLoading && (
                        <CircularProgress size={20} color="inherit" />
                      )}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
              />
            )}
            renderOption={(props, option) => (
              <li {...props}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Avatar
                    src={option.talentImage}
                    sx={{ width: 32, height: 32 }}
                  />
                  <Box>
                    <div>
                      {option.firstName} {option.lastName}
                    </div>
                    <small>{option.email}</small>
                  </Box>
                </Box>
              </li>
            )}
            fullWidth
          />
        )}

        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              name="contactName"
              label="Contact Name"
              value={formData.contactName || ""}
              onChange={handleChange}
              error={false}
              helperText=""
              margin="normal"
              disabled={disabledFields.contactName}
            />

            <TextField
              fullWidth
              name="company"
              label="Company"
              value={formData.company || ""}
              onChange={handleChange}
              error={false}
              helperText=""
              margin="normal"
              disabled={disabledFields.company}
            />

          <PhoneNumberField
  phoneNumber={formData.contactPhone || ""}
  label="Contact Phone"
  onChange={({ phoneNumber }) => {
    setTouched((prev) => ({
      ...prev,
      contactPhone: true,
    }));


    dispatch({
      type: "UPDATE_FIELD",
      field: "contactPhone",
      value: phoneNumber,
    });

    validateField("contactPhone", phoneNumber);
  }}
  error={!!errors.contactPhone || !!phoneError}
  helperText={errors.contactPhone || phoneError}
  required
  className="marginPhoneNumberField"
/>
            <Typography variant="subtitle2" sx={{ color: "#202020" }}>
              This will not show in ad. For admin use only
            </Typography>

            <TextField
              fullWidth
              name="contactEmail"
              label="Email"
              value={formData.contactEmail || ""}
              onChange={(e) => {
                handleChange(e);
                const regex = /^[^\s@]+@[^\s@]+\.[A-Za-z]{2,}$/;
                setEmailError(
                  regex.test(e.target.value) ? "" : "Invalid email format",
                );
              }}
              error={!!errors.contactEmail || !!emailError}
              helperText={errors.contactEmail || emailError}
              margin="normal"
              disabled={disabledFields.contactEmail}
            />

            <Box mt={2}>
              <InputLabel htmlFor="projectDescription">
                Project Description
              </InputLabel>
              <TextareaAutosize
                id="projectDescription"
                name="projectDescription"
                minRows={3}
                value={formData.projectDescription || ""}
                onChange={handleChange}
                style={{
                  width: "100%",
                  padding: "8px",
                  fontFamily: "inherit",
                  fontSize: "1rem",
                  borderColor: errors.projectDescription
                    ? "#f44336"
                    : "#c4c4c4",
                  borderRadius: 4,
                  resize: "vertical",
                }}
              />
              {errors.projectDescription && (
                <Typography variant="caption" color="error">
                  {errors.projectDescription}
                </Typography>
              )}
            </Box>

            <FormControl fullWidth margin="normal" size="small">
              <InputLabel id="audition-location-label">
                Audition Locations
              </InputLabel>
              <Select
                labelId="audition-location-label"
                multiple
                name="auditionLocations"
                value={formData.auditionLocations || []}
                onChange={(e) => {
                  const selected = e.target.value;
                  const previouslySelected = formData.auditionLocations || [];

                  const isSelectingNationwide =
                    selected.includes("NW") &&
                    !previouslySelected.includes("NW");
                  const isDeselectingNationwide =
                    !selected.includes("NW") &&
                    previouslySelected.includes("NW");

                  let updatedSelection = [];

                  if (isSelectingNationwide) {
                    updatedSelection = ["NW"];
                  } else if (isDeselectingNationwide) {
                    updatedSelection = [];
                  } else if (previouslySelected.includes("NW")) {
                    updatedSelection = ["NW"];
                  } else {
                    updatedSelection = selected.filter((val) => val !== "NW");
                  }

                  dispatch({
                    type: "UPDATE_FIELD",
                    field: "auditionLocations",
                    value: updatedSelection,
                  });
                }}
                renderValue={(selected) => (
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                    {selected.map((val) => {
                      const item = locationOptions.find((i) => i.value === val);
                      return <Chip key={val} label={item?.label || val} />;
                    })}
                  </Box>
                )}
              >
                {locationOptions.map((opt) => {
                  const isNationwideSelected =
                    formData.auditionLocations?.includes("NW");
                  const isCurrentNationwide = opt.value === "NW";
                  const shouldDisable =
                    isNationwideSelected && !isCurrentNationwide;

                  return (
                    <MenuItem
                      key={opt.value}
                      value={opt.value}
                      disabled={shouldDisable}
                    >
                      <Checkbox
                        checked={formData.auditionLocations?.includes(
                          opt.value,
                        )}
                        disabled={shouldDisable}
                      />
                      <ListItemText primary={opt.label} />
                    </MenuItem>
                  );
                })}
              </Select>
              {errors.auditionLocations && (
                <Typography variant="caption" color="error">
                  {errors.auditionLocations}
                </Typography>
              )}
            </FormControl>

            <FormControl fullWidth error={!!errors.jobCategories}>
              <InputLabel>Job Categories</InputLabel>
              <Select
                multiple
                name="jobCategories"
                value={formData.jobCategories || []}
                onChange={handleChange}
                input={<OutlinedInput label="Job Categories" />}
                renderValue={(ids) =>
                  ids.map((id) => jobCategoryMap[id]).join(", ")
                }
              >
                {categoryOptions.map((cat) => (
                  <MenuItem key={cat.id} value={cat.id}>
                    <Checkbox
                      checked={formData.jobCategories?.includes(cat.id)}
                    />
                    <ListItemText primary={cat.name} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6}>
        <FormControl fullWidth margin="normal" error={!!errors.unionStatus}>
  <InputLabel>Union Status</InputLabel>

  <Select
    multiple
    name="unionStatus"
    value={formData.unionStatus || []}
    onChange={handleChange}
    input={<OutlinedInput label="Union Status" />}
    renderValue={(selected) => (
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
        {selected.map((val) => (
          <Chip key={val} label={val} />
        ))}
      </Box>
    )}
  >
    {unionOptions.map((option) => (
      <MenuItem
        key={option.affiliationId}
        value={option.affiliationName}
      >
        <Checkbox
          checked={formData.unionStatus?.includes(option.affiliationName)}
        />
        <ListItemText primary={option.affiliationName} />
      </MenuItem>
    ))}
  </Select>

  {errors.unionStatus && (
    <Typography variant="caption" color="error">
      {errors.unionStatus}
    </Typography>
  )}
</FormControl>

            <Box mt={2}>
              <InputLabel htmlFor="castingOrShootDatesInfo">
                Casting / Shoot Info
              </InputLabel>
              <TextareaAutosize
                id="castingOrShootDatesInfo"
                name="castingOrShootDatesInfo"
                minRows={3}
                value={formData.castingOrShootDatesInfo || ""}
                onChange={handleChange}
                style={{
                  width: "100%",
                  padding: "8px",
                  fontFamily: "inherit",
                  fontSize: "1rem",
                  borderColor: errors.castingOrShootDatesInfo
                    ? "#f44336"
                    : "#c4c4c4",
                  borderRadius: 4,
                  resize: "vertical",
                }}
              />
              {errors.castingOrShootDatesInfo && (
                <Typography variant="caption" color="error">
                  {errors.castingOrShootDatesInfo}
                </Typography>
              )}
            </Box>
            <FormControl fullWidth margin="normal" error={!!errors.paymentType}>
              <InputLabel>Pay Type</InputLabel>
              <Select
                name="paymentType"
                value={formData.paymentType ? Number(formData.paymentType) : ""}
                onChange={handleChange}
                input={<OutlinedInput label="Pay Type" />}
              >
                {payTypeOptions.map((type) => (
                  <MenuItem key={type.id} value={type.id}>
                    {type.label}
                  </MenuItem>
                ))}
              </Select>

              {errors.payType && (
                <Typography variant="caption" color="error">
                  {errors.payType}
                </Typography>
              )}
            </FormControl>

            <TextField
              fullWidth
              name="payScale"
              label="Pay Scale"
              value={formData.payScale || ""}
              onChange={(e) => {
                if (e.target.value.length <= 200) handleChange(e);
              }}
              margin="normal"
              error={!!errors.payScale}
              helperText={
                errors.payScale
                  ? errors.payScale
                  : `${(formData.payScale || "").length}/200 characters`
              }
            />

            <TextField
              fullWidth
              name="removalDate"
              label="Expiration Date"
              type="date"
              placeholder="dd-mm-yyyy"
              value={formData.removalDate || ""}
              onChange={handleChange}
              margin="normal"
              InputLabelProps={{ shrink: true }}
              error={!!errors.removalDate}
              helperText={errors.removalDate}
            />

            <FormControlLabel
              control={
                <Switch
  checked={isWithinWeek ? true : formData.rushCall || false}
  disabled={isWithinWeek}
  onChange={(e) => {
    setManualRushOverride(true);
    dispatch({
      type: "UPDATE_FIELD",
      field: "rushCall",
      value: e.target.checked,
    });
  }}
/>
              }
              label="Rush Call"
            />

            <Box mt={3}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Button variant="contained" component="label" sx={{ mt: 1 }}>
                  Upload Picture
                  <input
                    type="file"
                    name="PicturesFile"
                    hidden
                    accept=".jpg,.jpeg,.png,.gif,.webp,.svg,.bmp,.tiff,.heic"
                    onChange={handleChange}
                  />
                </Button>
                <Typography
                  variant="subtitle2"
                  gutterBottom
                  pl={2}
                  color="#202020"
                >
                  Uploaded Photo (.jpg, .png, .gif, etc.)
                </Typography>
              </Box>

              {formData.PicturesFileName && (
                <Box display="flex" alignItems="center" mt={1} gap={1}>
                  <Typography variant="body2">
                    {formData.PicturesFileName}
                  </Typography>
                  <IconButton
                    size="small"
                    onClick={() =>
                      dispatch({
                        type: "MARK_FILE_REMOVED",
                        field: "PicturesFile",
                        nameField: "PicturesFileName",
                        removalFlag: "removePicturesFile",
                      })
                    }
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </Box>
              )}

              {fileError && (
                <Typography variant="body2" color="error" mt={0.5}>
                  {fileError}
                </Typography>
              )}
            </Box>

            <Box mt={3}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "baseline",
                }}
              >
                <Button variant="contained" component="label" sx={{ mt: 1 }}>
                  Upload Script
                  <input
                    type="file"
                    name="ScriptsFile"
                    hidden
                    accept=".pdf,.doc,.docx,.otf,.pages"
                    onChange={handleChange}
                  />
                </Button>
                <Typography
                  variant="subtitle2"
                  gutterBottom
                  pl={2}
                  color="#202020"
                >
                  Uploaded Script (.pdf, .doc, .docx, .otf, .pages)
                </Typography>
              </Box>

              {formData.ScriptsFileName && (
                <Box display="flex" alignItems="center" mt={1} gap={1}>
                  <Typography variant="body2">
                    {formData.ScriptsFileName}
                  </Typography>
                  <IconButton
                    size="small"
                    onClick={() =>
                      dispatch({
                        type: "MARK_FILE_REMOVED",
                        field: "ScriptsFile",
                        nameField: "ScriptsFileName",
                        removalFlag: "removeScriptsFile",
                      })
                    }
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </Box>
              )}

              {filewordError && (
                <Typography variant="body2" color="error" mt={0.5}>
                  {filewordError}
                </Typography>
              )}
            </Box>
          </Grid>
        </Grid>

        <Box display="flex" justifyContent="space-between" mt={3}>
          {!isAdmin && (
            <Button
              variant="outlined"
              sx={{ color: "#90b5fe", borderColor: "#90b5fe" }}
              onClick={() => handleSubmit("draft")}
              disabled={isLoading}
            >
              SAVE AS DRAFT
            </Button>
          )}

          <Button
            variant="contained"
            sx={{
              backgroundColor: "#90b5fe",
              ...(isAdmin && { ml: "auto" }),
            }}
            onClick={() => handleSubmit("in-progress")}
            disabled={isLoading}
          >
            SAVE AND CONTINUE
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

export default CastingCallForm;
